import { Observable } from 'rxjs';
import {
  ApiService,
  GET_USER_RANK_PATH,
  GET_USERS_TOP_RANK_PATH,
  GetUserRankPathParams,
  GetUserRankResponse,
  GetUsersTopRankResponse
} from '@core-http';

export class RankService extends ApiService {
  getUserRank(pathParams: GetUserRankPathParams): Observable<GetUserRankResponse> {
    const path: string = this.fillPathParams(GET_USER_RANK_PATH, pathParams);

    return this.httpClient.get<GetUserRankResponse>(`${this.env.apiUrl}${path}`);
  }

  getTop50(): Observable<GetUsersTopRankResponse> {
    return this.httpClient.get<GetUsersTopRankResponse>(`${this.env.apiUrl}${GET_USERS_TOP_RANK_PATH}`);
  }
}
